module.exports = __webpack_public_path__ + "img/children_excited.8dc620b2.jpg";